import { axios } from '@/services/axios';

const verifySSOProvider = async ({ accessToken, ssoid }) => {
    const res = await axios.post('/sso/verify', { accessToken, ssoid });
    return res.data;
};

export default verifySSOProvider;
